import { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { NoMatchPage } from "components/NoMatchPage";
import HistoryDetails from "./historyDetails";
import { HistoryPage } from "./HistoryPage";
import { SearchHistoryPage } from "./SearchHistoryPage";
import { ServiceHistoryPage } from "./ServiceHistoryPage";

const Router: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HistoryPage />} />
      <Route path="/search" element={<SearchHistoryPage />} />
      <Route path=":id/*" element={<HistoryDetails />} />
      <Route path="/:type/:typeId" element={<ServiceHistoryPage />} />
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
